import React, {useCallback, useContext} from "react";
import {forms} from "../forms";
import {MtplQuotation, Quotation} from "../../../model/quotation";
import {StepProps} from "../step-props";
import {Stage} from "../../../api/model/scenario";
import {ScenarioContext} from "../../../contexts/ScenarioContext";
import {StepContext} from "../../../contexts/StepContext";
import {MtplScenarioHeader} from "../forms/MtplScenarioHeader";

export const MtplPersonalInfoStep = ({step}: StepProps) => {
    const {currentStep, backStageHandler} = useContext(ScenarioContext);
    const {nextStepListener, backStepListener} = useContext(StepContext);

    const onFormSubmit = useCallback((submittedQuotation: MtplQuotation) => {
        nextStepListener(submittedQuotation);
    }, [nextStepListener]);

    const backStepHandler = (quotation: Quotation) => {
        backStepListener(quotation, (stage: Stage) => {
            const currentStepIndex = stage.steps.indexOf(currentStep);
            let newPreviousStep = currentStep;
            if (currentStepIndex === 0) {
                if (newPreviousStep && (newPreviousStep.code === "mtpl_online_00002" || newPreviousStep.code === "mtpl_online_00005")) {
                    backStageHandler(quotation);
                }
            }
        });
    };

    return (
        <>
            <MtplScenarioHeader/>

            {step.forms.map(form => {
                return React.createElement(forms[form.code], {
                    key: form.code,
                    onFormSubmit,
                    backStepHandler
                })
            })}
        </>
    );
};
